module.exports = __webpack_public_path__ + "static/media/oasis3.f3b43df6.jpg";